<template>
  <v-app>
    <v-toolbar color="secondary" app>
      <v-toolbar-side-icon dark @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-divider vertical></v-divider>
      <img src="/static/logo.png" style="height: 50%; margin-left: 1%" />
      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat dark @click="logout"><v-icon>exit_to_app</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" app dark>
      <v-divider></v-divider>
      <v-subheader class="mt-3 grey--text text--darken-1">
        <v-avatar :title="'Exasol AG'" color="grey lighten-4">
          <img src="/static/avatar.png" alt="avatar" />
        </v-avatar>
      </v-subheader>
      <v-list>
        <v-divider></v-divider>
        <v-list-tile @click="activate_panel('cluster_modificator_active')">
          <v-list-tile-action>
            <v-icon>create</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title elevation-5>Cluster Modificator</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content app dark>
      <clustermodificator></clustermodificator>
    </v-content>

    <v-footer color="secondary" app>
      <v-bottom-sheet v-model="sheet" class="text-md-center">
        <v-btn slot="activator" flat dark> Help </v-btn>
        <v-list>
          <v-list-tile>
            <v-list-tile-title
              ><a href="https://exasol.com/exasol-on-aws" target="_blank">Documentation</a></v-list-tile-title
            >
            <v-list-tile-title
              ><a class="external-link" href="https://www.exasol.com/en/company/contact" target="_blank" rel="noopener"
                >Contact</a
              ></v-list-tile-title
            >
          </v-list-tile>
        </v-list>
      </v-bottom-sheet>

      <v-spacer></v-spacer>
      <div style="color: #00b09b">&copy; Exasol {{ new Date().getFullYear() }}</div>
      <v-spacer></v-spacer>
      <a
        style="color: #00b09b; padding-right: 1%"
        href="https://www.exasol.com/en/legal-disclosure/"
        target="_blank"
        rel="noopener"
        >Legal Disclosure</a
      >
      <a
        style="color: #00b09b; padding-right: 1%"
        href="https://www.exasol.com/en/privacy-policy/"
        target="_blank"
        rel="noopener"
        >Privacy Policy</a
      >
    </v-footer>
  </v-app>
</template>

<script>
import clustermodificator from '@/components/modificator/ClusterModificator';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Home',
  components: {
    clustermodificator,
  },
  data() {
    return {
      msg: 'Home',
      drawer: false,
      sheet: false,
    };
  },

  methods: {
    activate_panel(panel_key) {
      Object.keys(this.panels).forEach((x) => {
        this.panels[x] = x == panel_key ? true : false;
      });
    },
    logout() {
      localStorage.clear();
      this.$router.push('/login');
    },
  },
};
</script>

<style>
@-webkit-keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.loading-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 1;
}
.loading-overlay.is-active {
  display: flex;
}
.loading-overlay.is-full-page {
  z-index: 999;
  position: fixed;
}
.loading-overlay.is-full-page .loading-icon:after {
  top: calc(50% - 2.5em);
  left: calc(50% - 2.5em);
  width: 5em;
  height: 5em;
}
.loading-overlay .loading-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}
.loading-overlay .loading-icon {
  position: relative;
}
.loading-overlay .loading-icon:after {
  -webkit-animation: spinAround 500ms infinite linear;
  animation: spinAround 500ms infinite linear;
  border: 2px solid #777;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: '';
  display: block;
  height: 5em;
  position: relative;
  width: 5em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
</style>
